import { FormInstance } from "antd";
import { useCallback, useState } from "react";
import { useAppDispatch } from "../../../store";
import { sendPayoffQuotesForReview } from "../../../acions/administration/fillableForms";

export const useSendPayoff = (
  contractNumber: string,
  form: FormInstance,
  close: () => void,
) => {
  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState(false);

  const send = useCallback(async () => {
    try {
      const data = await form.validateFields();

      setIsLoading(true);

      const request = {
        intendedPayoffDate: data.intendedPayoffDate.startOf("D").format(),
      };

      await Promise.resolve(
        dispatch(sendPayoffQuotesForReview(contractNumber, request)),
      );

      setIsLoading(false);

      close();
    } catch {
      setIsLoading(false);
    }
  }, [contractNumber, dispatch, form, close]);

  return { send, isLoading };
};
